import Inputs from './inputs';

export default function () {
    var filterFields;
    var filterHtml = '';
    var radioIcon =
        '<svg viewBox="0 0 24 24"><circle r="8" cx="12" cy="12"></circle></svg>';
    var checkBoxIcon =
        '<svg viewBox="0 0 24 24"><path d="M9.001,16.212l-4.199-4.2l-1.4,1.4l5.6,5.6l12-12l-1.4-1.4L9.001,16.212z"></path></svg>';

    var SmartFilter = function (form) {
        this.lastChangedField = null;
        this.form = form || $('#sm-filter');
        this.wrapForm();
        return this;
    };

    SmartFilter.prototype.setLastChangedField = function (element) {
        this.lastChangedField = element;
        return this;
    };

    SmartFilter.prototype.wrapForm = function () {
        $(this.form).wrap('<div class="sm-filter-wrapper"></div>');
        this.wrapper = $(this.form).closest('.sm-filter-wrapper');
        this.wrapper.prepend(`
			<div class="sm-filter-head">
				<div class="sm-filter-head__text">Подбор по параметрам
					<svg version="1.1" height="20" width="18" viewBox="0 0 18 20" aria-hidden="true" class="sst-svg-icon sm-filter-head__button">
						<path d="M0,15v2h6v-2H0z M0,3v2h10V3H0z M10,19v-2h8v-2h-8v-2H8v6H10z M4,7v2H0v2h4v2h2V7H4z M18,11V9H8v2H18z M12,7h2V5h4V3h-4V1h-2V7z"></path>
					</svg>
				</div>
			</div>
		`);
        this.wrapper.closest('.sst-col').css('z-index', 20);
        return this;
    };

    SmartFilter.prototype.disable = function () {
        $(this.form).addClass('sm-filter--disabled');
        this.wrapper.append('<div class="sm-filter__overlay">');
        return this;
    };

    SmartFilter.prototype.enable = function () {
        $(this.form).removeClass('sm-filter--disabled');
        this.wrapper.find('.sm-filter__overlay').remove();
        return this;
    };

    SmartFilter.prototype.reset = function () {
        $(this.form)
            .find('.sst-field__input')
            .each(function () {
                var $this = $(this);
                $this.removeClass('sm-filter__field--inactive');
                $this.removeAttr('disabled');
                $('.sm-filter-result').remove();
                switch ($this.attr('type')) {
                    case 'text':
                        $this.val('').data('dirty', false);
                        break;
                    case 'radio':
                        $this.prop('checked', false);
                        break;
                    case 'checkbox':
                        $this.prop('checked', false);
                        break;
                }
            });
        this.applyFilter();
        return this;
    };

    SmartFilter.prototype.applyFilter = function () {
        var dataString = $(this.form).serialize();
        history.replaceState(
            null,
            '',
            location.href.split('?')[0] + (dataString ? '?' + dataString : '')
        );
        location.reload();
    };

    var smFilter = new SmartFilter();
    //var

    $.ajax({
        url:
            smFilter.form.attr('data-smart-filter-form-content-url') +
            window.location.search.replace('?', '&'),
        data: smFilter.form.serialize(),
        dataType: 'json',
        type: 'get',
        success: function (data) {
            buildFilterMarkup(data);
            updateShortStates();
        },
    });

    $(document).on('click', '.sm-filter-head', function () {
        $(this).closest('.sm-filter-wrapper').toggleClass('m-active');
    });

    $(document).on('click', '.sm-filter-section__head', function () {
        if ($(this).hasClass('.sm-filter-section__checkbox')) return;
        $(this).closest('.sm-filter-section').toggleClass('active');
    });

    $(document).on('click', '.sm-filter__show-more', function () {
        $(this)
            .closest('.sm-filter-section--toggleable')
            .toggleClass('sm-filter-section--active');
    });

    $(document).on('click', '.sm-filter__reset', function () {
        smFilter.reset();
    });

    $(document).on('click', '.sm-filter-result', function (e) {
        e.preventDefault();
    });

    $(document).on('click', '.sm-filter-result__link', function (e) {
        e.preventDefault();
        smFilter.applyFilter();
    });

    $(document).on('click', '.sm-filter__submit', function (e) {
        e.preventDefault();
        $(this).prop('disabled', true);
        smFilter.applyFilter();
    });

    $(document).on('change', '.sm-filter .sst-field__input', function (e) {
        smFilter.disable().setLastChangedField($(this));
        placeResultPreloader($(this));
        updateShortStates();
        $.ajax({
            url: smFilter.form.attr('data-smart-filter-form-content-url'),
            data: smFilter.form.serialize(),
            dataType: 'json',
            type: 'get',
            success: function (data) {
                setTimeout(function () {
                    smFilter.enable();
                    updateFilter(data);
                    updateResult(data);
                }, 500);
            },
        });
    });

    function updateShortStates() {
        smFilter.form.find('.sm-filter-section').each(function (index, el) {
            var section = $(this);
            var output = $(this).find('.sm-filter-section__short-state');
            var result = [];

            section
                .find('input[type=checkbox], input[type=radio]')
                .each(function (index, el) {
                    if ($(this).prop('checked') == true) {
                        var labelText = $(this)
                            .siblings('.sst-field__label')
                            .children('.sst-field__label-text')
                            .text();
                        if (result.indexOf(labelText) == -1) {
                            result.push(labelText);
                        }
                    }
                });

            output.text(result.toString().replace(/,/g, ', '));
        });
    }

    function placeResultPreloader(element) {
        $('.sm-filter-result').remove();

        switch (element.attr('type')) {
            case 'radio':
            case 'checkbox':
                element.next('.sst-field__label').append(resultMarker());
                break;
            case 'text':
                element.closest('.sm-filter__grid').append(resultMarker());
        }
    }

    function updateResult(data) {
        $('.sm-filter-result').replaceWith(resultMarker(data));
        $('.sm-filter-result').addClass('ready');
    }

    function updateFilter(data) {
        if (data.wherePart !== undefined) {
            $('.shop-catalog__title').text(data.wherePart);
        }

        filterFields = data.filterFields || [];

        filterFields.forEach(function (group) {
            switch (group.type) {
                case 'mul':
                case 'rad':
                case 'cbx':
                    group.values.forEach(function (inputData) {
                        var $input;
                        $input = $(
                            "[name='" +
                                group.name +
                                "'][value='" +
                                inputData.value +
                                "']"
                        );
                        $input.prop('checked', inputData.checked);
                        if (inputData.active == true) {
                            $input.removeClass('sm-filter__field--inactive');
                            $input.removeAttr('disabled');
                        }
                        if (inputData.active == false) {
                            $input.addClass('sm-filter__field--inactive');
                            $input.attr('disabled', true);
                        }
                    });

                    break;
                case 'rng':
                    var $inputFrom;
                    var $inputTo;
                    var loRng = group.values.filter(function (e) {
                        return e.name == 'loRng';
                    });
                    var hiRng = group.values.filter(function (e) {
                        return e.name == 'hiRng';
                    });
                    var from = group.values.filter(function (e) {
                        return e.name == 'from';
                    });
                    var to = group.values.filter(function (e) {
                        return e.name == 'to';
                    });

                    $inputFrom = $(".from[name='" + group.name + "']");
                    $inputTo = $(".to[name='" + group.name + "']");

                    $inputFrom.val(from[0].value);
                    $inputFrom
                        .closest('.sst-field')
                        .find('.sst-field__label-text')
                        .text(loRng[0].value);
                    Inputs.checkDirty($inputFrom[0]);

                    $inputTo.val(to[0].value);
                    $inputTo
                        .closest('.sst-field')
                        .find('.sst-field__label-text')
                        .text(hiRng[0].value);
                    Inputs.checkDirty($inputTo[0]);

                    break;
            }
        });
    }

    function buildFilterMarkup(data) {
        if (data.wherePart !== undefined) {
            $('.shop-catalog__title').text(data.wherePart);
        }

        filterFields = data.filterFields || [];

        if (filterFields.length === 0) return;

        filterFields.forEach(function (group) {
            makeGroup(group);
        });
        makeMainButtons();
        makeFilterMarkup();
    }

    function makeFilterMarkup() {
        $(smFilter.form).html(filterHtml);
        $(smFilter.wrapper).addClass('sm-filter-ready');
    }

    function makeGroupHeader(data) {
        return (
            '<div class="sm-filter-section__head"><div class="sm-filter-section__title">' +
            (data.descr ? data.descr : '') +
            '<div class="sm-filter-section__short-state"></div></div></div>'
        );
    }

    function makeSectionBegin(toggleable) {
        return (
            '<div class="sm-filter-section active' +
            (toggleable ? ' sm-filter-section--toggleable' : '') +
            '">'
        );
    }

    function makeSectionEnd() {
        return '</div>';
    }

    function makeBodyBegin() {
        return '<div class="sm-filter-section__body">';
    }

    function makeBodyEnd() {
        return '<button type="button" class="sm-filter__show-more"><span>Показать больше</span><span class="sm-filter__show-more-active">Показать меньше</span></button></div>';
    }

    function makeGroup(group) {
        var toggleable = Object.keys(group.values).length > 10 ? true : false;

        filterHtml += makeSectionBegin(toggleable);

        if (group.type !== 'cbx') {
            filterHtml += makeGroupHeader(group);
            filterHtml += makeBodyBegin();
        }

        switch (group.type) {
            case 'mul':
                for (var i in group.values) {
                    filterHtml += switcher(
                        'checkbox',
                        group.values[i],
                        group.name
                    );
                }
                break;
            case 'rad':
                for (var i in group.values) {
                    filterHtml += switcher(
                        'radio',
                        group.values[i],
                        group.name
                    );
                }
                break;
            case 'cbx':
                filterHtml +=
                    '<div class="sm-filter-section__head sm-filter-section__checkbox">';
                for (var i in group.values) {
                    filterHtml += switcher(
                        'checkbox',
                        group.values[i],
                        group.name,
                        group.descr
                    );
                }
                filterHtml += '</div>';
                break;
            case 'rng':
                var loRng = group.values.filter(function (e) {
                    return e.name == 'loRng';
                });
                var hiRng = group.values.filter(function (e) {
                    return e.name == 'hiRng';
                });
                var from = group.values.filter(function (e) {
                    return e.name == 'from';
                });
                var to = group.values.filter(function (e) {
                    return e.name == 'to';
                });

                filterHtml += '<div class="sst-grid sm-filter__grid">';

                filterHtml +=
                    '<div class="sst-col sst-col--1of2 sm-filter__range-col">';
                filterHtml += '<div class="sm-filter__before-text">От</div>';
                filterHtml += input(
                    'text',
                    loRng[0].value,
                    from[0].value,
                    group.name,
                    'from sst-field__nums-only'
                );
                filterHtml += '</div>';

                filterHtml +=
                    '<div class="sst-col sst-col--1of2 sm-filter__range-col">';
                filterHtml += '<div class="sm-filter__before-text">до</div>';
                filterHtml += input(
                    'text',
                    hiRng[0].value,
                    to[0].value,
                    group.name,
                    'to sst-field__nums-only'
                );
                filterHtml += '</div>';

                filterHtml += '</div>';

                break;
        }

        if (group.type !== 'cbx') {
            filterHtml += makeBodyEnd();
        }
        filterHtml += makeSectionEnd();
    }

    function makeMainButtons() {
        filterHtml += '<div class="sm-filter__footer">';
        filterHtml += '<div class="sst-grid sst-grid--thin sm-filter__grid">';

        filterHtml += '<div class="sst-col sst-col--1of2">';
        filterHtml +=
            '<button type="button" class="sm-filter__submit sst-button sst-button--primary sst-button--wide sst-button--material sst-button--radius sst-padding--0"><span>Показать</span><span class="la-ball-fall"><span></span><span></span><span></span></span></button>';
        filterHtml += '</div>';

        filterHtml += '<div class="sst-col sst-col--1of2">';
        filterHtml +=
            '<button type="button" class="sst-button sst-button--wide sm-filter__reset sst-button--material sst-button--radius sst-padding--0">Сбросить</button>';
        filterHtml += '</div>';

        filterHtml += '</div>';
        filterHtml += '</div>';
    }

    function input(type, label, value, name, className) {
        return (
            '<label class="sst-field sst-field--text">' +
            '<input class="sst-field__input' +
            (className ? ' ' + className : '') +
            '" type="text" name="' +
            name +
            '" data-dirty="' +
            (value ? true : false) +
            '" value="' +
            (value ? value : '') +
            '">' +
            '<span class="sst-field__label"><span class="sst-field__label-text">' +
            label +
            '</span></span>' +
            '<span class="sst-field__error"></span>' +
            '<span class="sst-field__hr"></span>' +
            '</label>'
        );
    }

    function switcher(type, data, name, label) {
        return (
            '<label class="sst-field"><input ' +
            (!data.active ? 'disabled' : '') +
            ' class="sst-field__input' +
            (!data.active ? ' sm-filter__field--inactive' : '') +
            '" name="' +
            name +
            '" type="' +
            type +
            '" ' +
            (data.checked ? 'checked' : '') +
            ' value="' +
            (data.value ? data.value : '') +
            '"><span class="sst-field__label"><span class="sst-field__label-text">' +
            (label ? label : data.name) +
            '</span><span class="sst-field__icon">' +
            (type == 'checkbox' ? checkBoxIcon : radioIcon) +
            '</span></span></label>'
        );
    }

    function resultMarker(data) {
        data = data || {};
        return (
            '<span class="sm-filter-result">' +
            '<span class="sm-filter-result__text">' +
            '<span class="sm-filter-result__word">Позиций:</span>' +
            '<span class="sm-filter-result__count">' +
            (data.prodCount ? data.prodCount : 0) +
            '</span>' +
            '<span class="la-ball-fall"><span></span><span></span><span></span></span>' +
            '</span>' +
            (data.prodCount && data.prodCount > 0
                ? '<a class="sm-filter-result__link">Показать</a>'
                : '') +
            '</span>'
        );
    }

    $(document).on('keydown', '.sst-field__nums-only', function (event) {
        var input, parent, val, min, max, key;

        if (
            event.keyCode == 46 ||
            event.keyCode == 8 ||
            event.keyCode == 9 ||
            (event.keyCode == 65 && event.ctrlKey === true) ||
            (event.keyCode >= 35 && event.keyCode <= 39)
        ) {
            return;
        } else if (event.keyCode == 13 || event.keyCode == 27) {
            $(this).blur();
            return;
        } else {
            // If it's not a number stop the keypress
            if (
                event.shiftKey ||
                ((event.keyCode < 48 || event.keyCode > 57) &&
                    (event.keyCode < 96 || event.keyCode > 105))
            ) {
                event.preventDefault();
            }
        }
    });
}
